import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"

export const activities = {
    getActivitiesType,
    getActivities,
    updateActivity,
    getActivity
}

async function getActivitiesType({
    page = 1,
    size = 10,
    state = "ACTIVE",
    search_value,
    include_total = true,

} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/activities/types',
            queryParams: {
                page,
                size,
                state,
                search_value,
                include_total
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getActivitiesType: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getActivities({
    page = 1,
    size = 10,
    type_id,
    order_id,
    include_total = true,
    include_custom_fields= true,
    state='PENDING,COMPLETED'
} = {},) {
    try {
        let id = httpBackOfficeUtil.getSession().sub;
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/activities',
            queryParams: {
                page,
                size,
                type_id,
                order_id,
                include_total,
                include_custom_fields,
                assigned_to_user_id: id,
                state
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getActivities: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getActivity(activityId) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: `/v2/activities/${activityId}`,
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getActivitie: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateActivity({
    activity_id,
    state,
    custom_fields
} = {}) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: '/v2/activities/' + activity_id,
            withAccessToken: true,
            body: {
                state,
                custom_fields
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA updateActivity: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}